export const HERO_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/e07b1da6-2211-4226-93e0-3f184789bed4/images/95de67bd618024ed12e7d81953a4eed8b1f8e13e4cf79cdb5d3c4be2de8acddd.jpeg";
export const DOUGH_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/e07b1da6-2211-4226-93e0-3f184789bed4/images/211dcb46b4f1c9d3cfda6e9eef76b710901cc982cb4ec4b3006763f3f392cbb0.jpeg";
export const OVEN_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/e07b1da6-2211-4226-93e0-3f184789bed4/images/e57957aa942e55f53176673597d2b0e113d4bc2478851c16357ce2688ea9bd26.jpeg";
export const EVENING_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/e07b1da6-2211-4226-93e0-3f184789bed4/images/a30db71c87930cc1eec5f0e596bbf239a548eceb936b99173ec1e1318266e336.jpeg";
export const MARGHERITA_IMAGE =
  "https://customer-assets.emergentagent.com/job_eatery-fixes/artifacts/7351dpk0_Pizza%20margherita.jpg";
export const SALAMI_IMAGE =
  "https://customer-assets.emergentagent.com/job_eatery-fixes/artifacts/j5o6cldx_Pizza%20salami.jpg";
export const INSTAGRAM_URL =
  "https://www.instagram.com/rozedinapoli/?igsh=MTAwcXNidWRsdW0ydA%3D%3D&utm_source=qr";

export const scrollToId = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
};
export const scrollToMenu = () => scrollToId("menu-section");

export const Wordmark = ({ className = "", size = "hero", tone = "light" }) => {
  const color = tone === "light" ? "text-[#FDFBF7]" : "text-[#1C1917]";
  const sizes = {
    hero: { a: "text-[clamp(3.6rem,11vw,8.5rem)] leading-[0.88]", b: "text-[clamp(1.55rem,4.8vw,3.65rem)] leading-[0.9] mt-[0.25em]" },
    nav: { a: "text-[1.35rem] leading-none", b: "text-[0.58rem] leading-none mt-[0.3em]" },
    footer: { a: "text-[clamp(2.6rem,5vw,4rem)] leading-[0.88]", b: "text-[clamp(1.1rem,2.2vw,1.72rem)] leading-[0.9] mt-[0.25em]" },
  }[size];
  return (
    <div className={`font-wordmark uppercase ${color} ${className}`} aria-label="Roze di Napoli">
      <span className={`block tracking-[0.01em] ${sizes.a}`}>Roze</span>
      <span className={`block tracking-[0.08em] ${sizes.b}`}>di Napoli</span>
    </div>
  );
};

export const HandUnderline = ({ className = "", color = "#1C1917" }) => (
  <svg viewBox="0 0 320 14" className={`block h-3 ${className}`} aria-hidden="true" preserveAspectRatio="none">
    <path d="M3 10.5 C 60 6.5, 120 5, 180 6 S 290 4.5, 317 7.5" fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);
